import { Advice } from './components/Advice';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
      <div>
        <Advice/>
      </div>
  );
}

export default App;
